import { render, staticRenderFns } from "./DealInformation.vue?vue&type=template&id=1b1d0f0c&"
import script from "./DealInformation.vue?vue&type=script&lang=ts&"
export * from "./DealInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports